<template>
    <nav class="navbar navbar-light navbar-expand-md fixed-top bg-light shadow-sm justify-content-start">
        <div class="container-fluid px-2">
            <a href="../" class="navbar-brand navbar-text" title="Home">Forque</a>
            <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarH">
                <span class="navbar-toggler-icon"></span>
            </button>
            <div class="navbar-collapse collapse" id="navbarH">
                <ul class="navbar-nav text-uppercase w-100">
                    <template v-for="(link,index) in navbarLinks">
                    <li class="nav-item" v-if="!link.children" :key="index" >
                        <router-link :to="link.path" :ref="link.name" class="nav-link">
                        {{ link.name }}
                        </router-link>
                    </li>
                    <li class="nav-item dropdown" v-if="link.children" :key="index" >
                        <router-link :to="link.path" :ref="link.name" class="nav-link dropdown-toggle" data-toggle="dropdown">
                        {{ link.name }}
                        </router-link>
                        <div class="dropdown-menu">
                            <router-link v-for="(child,i) in link.children" class="dropdown-item" :title="child.name" :to="child.path" :key="i">
                            {{ child.name }}
                            </router-link>
                        </div>
                    </li>
                    </template>
                    <li class="nav-item dropdown ml-md-auto ml-0">
                        <button class="nav-link btn btn-link p-0 text-truncate" data-toggle="dropdown">
                            <img alt="avatar" src="assets/m20.jpg" class="avatar rounded-circle bg-white shadow-sm" />
                        </button>
                        <div class="dropdown-menu dropdown-menu-right mt-2 rounded-0" aria-labelledby="dropdownMenu1">
                            <a class="dropdown-item px-3" href="#" @click="showProfile()"><span class="lnr lnr-user"></span> Profile</a>
                            <router-link class="dropdown-item px-3" :to="'/inbox'">
                                <span class="lnr lnr-inbox"></span> Inbox <span class="badge badge-primary badge-pill font-weight-light align-middle mb-1 pt-0" title="notify count"><small>3</small></span>
                            </router-link>
                            <div class="dropdown-divider"></div>
                            <a class="dropdown-item px-3" href="#" @click="showLogout()"><span class="lnr lnr-exit"></span> Logout</a>
                            <a class="dropdown-item px-3 font-weight-bold" href="http://themes.guide" target="_new" rel="nofollow">About Forque</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <ModalProfile ref="modalProfile" />
        <ModalLogout ref="modalLogout" />
    </nav>
</template>
<script>
import ModalProfile from "./ModalProfile";
import ModalLogout from "./ModalLogout";

export default {
    props: {
        navbarLinks: {
            type: Array,
            default: () => [
                {name:"Dashboards",path:"",
                    children:[
                    {name:"Dashboard 1",path:"/home"},
                    {name:"Dashboard 2",path:"/home1"},
                    {name:"Dashboard 3",path:"/home2"},
                    {name:"Dashboard 4",path:"/home3"}]
                },
                {name:"Charts",path:"/charts"},
                {name:"Inbox",path:"/inbox"},
                {name:"Kanban",path:"/tasks"},
                {name:"Search",path:"/search"},
                {name:"Tables",path:"/tables"},
                {name:"UI Kit",path:"",
                    children:[
                        {name:"Cards",path:"/cards"},
                        {name:"Forms",path:"/forms"},
                        {name:"Icons",path:"/icons"},
                        {name:"Typography",path:"/typography"},
                        {name:"Alerts",path:"/elements#alerts"},
                        {name:"Badges & Pills",path:"/elements#badges"},
                        {name:"Breadcrumbs",path:"/elements#breadcrumbs"},
                        {name:"Buttons",path:"/elements#buttons"},
                        {name:"Colors",path:"/elements#colors"},
                        {name:"Progress Bars",path:"/elements#progress"},
                        {name:"Lists & Accordions",path:"/elements#lists"},
                        {name:"Modals",path:"/elements#modals"},
                        {name:"Pagination",path:"/elements#breadcrumbs"},
                        {name:"Tables",path:"/elements#tables"},
                        {name:"Tabs",path:"/elements#tabs"},
                        {name:"Videos",path:"/elements#videos"}]
                },
                {name:"Pages",path:"",
                    children:[
                    {name:"Timeline",path:"/timeline"},
                    {name:"Gallery",path:"/gallery"},
                    {name:"Artwork",path:"/artwork"},
                    {name:"Pricing",path:"/pricing"},
                    {name:"FAQ",path:"/faq"},
                    {name:"Error 404",path:"/404"},
                    {name:"Error 500",path:"/500"}]
                },
                {name:"Layouts",path:"",
                    children:[
                    {name:"Layout 1",path:"/layout",icon:""},
                    {name:"Layout 2",path:"/layout1",icon:""}]
                }
            ]
        }
    },
    components: {
        ModalProfile,
        ModalLogout
    },
    methods: {
        showProfile() {
            this.$refs.modalProfile.show();
        },
        showLogout() {
            this.$refs.modalLogout.show();
        }
    }
};
</script>
